import { StyledRatingLink } from "./index.styled";
import SectionTitle from "../../dashboard/SectionTitle";
import { colors } from "../../../styles/colors";
import CopyButton from "../CopyButton";

interface RatingLinkProps {
  link: {
    text: string;
    shortLink?: string;
    longLink: string;
    triggerId: number;
  };
}

const RatingLink = ({ link }: RatingLinkProps) => {
  const { text, shortLink, longLink, triggerId } = link;

  return (
    <StyledRatingLink>
      <SectionTitle
        title="קישור לדירוג"
        titleStyle={{ fontSize: "14px", color: colors.blueGray }}
      />
      <div className="rating-link-inner">
        <div className="rating-link-text">{text}</div>
        <CopyButton
          shortLink={shortLink}
          longLink={longLink}
          triggerId={triggerId}
        />
      </div>
    </StyledRatingLink>
  );
};

export default RatingLink;
